<template>
  <path
    d="M7.58 16.8902L13.35 12.8202C13.91 12.4202 13.91 11.5802 13.35 11.1902L7.58 7.11018C6.91 6.65018 6 7.12018 6 7.93018V16.0702C6 16.8802 6.91 17.3502 7.58 16.8902ZM16 7.00018V17.0002C16 17.5502 16.45 18.0002 17 18.0002C17.55 18.0002 18 17.5502 18 17.0002V7.00018C18 6.45018 17.55 6.00018 17 6.00018C16.45 6.00018 16 6.45018 16 7.00018Z"
  />
</template>
